import { useEffect, useMemo, useState } from 'react';

import useTrackedAiRuns from './useTrackedAiRuns';
import { AI_IMPORT_SEEN_EVENT, isRunSeen, readSeenStatuses } from '../utils/aiImportRun';

/**
 * A superuser's AI imports of this browser not seen yet on the bulk import page with their current
 * status (a running one is never seen), newest first, and whether one runs. Follows what the bulk
 * import page marks seen, in this tab and in others.
 */
const useUnseenAiRuns = (enabled: boolean, getToken: () => string | undefined) => {
  const { runs, runningCount } = useTrackedAiRuns(enabled, getToken);
  const [seen, setSeen] = useState(readSeenStatuses);

  useEffect(() => {
    const update = () => setSeen(readSeenStatuses());
    window.addEventListener(AI_IMPORT_SEEN_EVENT, update);
    window.addEventListener('storage', update);
    return () => {
      window.removeEventListener(AI_IMPORT_SEEN_EVENT, update);
      window.removeEventListener('storage', update);
    };
  }, []);

  const unseen = useMemo(
    () => runs.filter(({ runId, status }) => status && !isRunSeen(runId, status.status, seen)),
    [runs, seen]
  );
  return { unseen, running: runningCount > 0 };
};

export default useUnseenAiRuns;
